export const LanguageEnum = Object.freeze({
    Sk: "sk",
    En: "en",
    Cs: "cs",
    Sl: "sl",
    Hr: "hr"
});

export const exists = code => {
    let key = Object.keys(LanguageEnum).find(key => LanguageEnum[key] === code);

    return key !== undefined;
}